import { render, staticRenderFns } from "./MerchantConfigurationDialog.vue?vue&type=template&id=0e654e34"
import script from "./MerchantConfigurationDialog.vue?vue&type=script&lang=ts"
export * from "./MerchantConfigurationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports